/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FriendInviteStatus } from './FriendInviteStatus';
import {
    FriendInviteStatusFromJSON,
    FriendInviteStatusFromJSONTyped,
    FriendInviteStatusToJSON,
    FriendInviteStatusToJSONTyped,
} from './FriendInviteStatus';

/**
 * 
 * @export
 * @interface FriendInviteResponse
 */
export interface FriendInviteResponse {
    /**
     * 
     * @type {string}
     * @memberof FriendInviteResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FriendInviteResponse
     */
    inviteCode: string;
    /**
     * 
     * @type {string}
     * @memberof FriendInviteResponse
     */
    inviteUrl: string;
    /**
     * 
     * @type {FriendInviteStatus}
     * @memberof FriendInviteResponse
     */
    status: FriendInviteStatus;
    /**
     * 
     * @type {string}
     * @memberof FriendInviteResponse
     */
    invitedEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof FriendInviteResponse
     */
    acceptedByUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof FriendInviteResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof FriendInviteResponse
     */
    expiresAt: number;
}



/**
 * Check if a given object implements the FriendInviteResponse interface.
 */
export function instanceOfFriendInviteResponse(value: object): value is FriendInviteResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('inviteCode' in value) || value['inviteCode'] === undefined) return false;
    if (!('inviteUrl' in value) || value['inviteUrl'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function FriendInviteResponseFromJSON(json: any): FriendInviteResponse {
    return FriendInviteResponseFromJSONTyped(json, false);
}

export function FriendInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FriendInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'inviteCode': json['inviteCode'],
        'inviteUrl': json['inviteUrl'],
        'status': FriendInviteStatusFromJSON(json['status']),
        'invitedEmail': json['invitedEmail'] == null ? undefined : json['invitedEmail'],
        'acceptedByUserId': json['acceptedByUserId'] == null ? undefined : json['acceptedByUserId'],
        'createdAt': json['createdAt'],
        'expiresAt': json['expiresAt'],
    };
}

export function FriendInviteResponseToJSON(json: any): FriendInviteResponse {
    return FriendInviteResponseToJSONTyped(json, false);
}

export function FriendInviteResponseToJSONTyped(value?: FriendInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'inviteCode': value['inviteCode'],
        'inviteUrl': value['inviteUrl'],
        'status': FriendInviteStatusToJSON(value['status']),
        'invitedEmail': value['invitedEmail'],
        'acceptedByUserId': value['acceptedByUserId'],
        'createdAt': value['createdAt'],
        'expiresAt': value['expiresAt'],
    };
}

